import Home from './pages/home/Home'
import Admin from './pages/admin/Admin'
import Navbar from './components/Navbar/Navbar'
import { Route, Routes } from "react-router-dom"

function App() {
  return (
    <>
      <Navbar/>
      <div>
        <Routes>
          <Route path = "/" element = {<Home/>}/>
          <Route path = "/home" element = {<Home/>}/>
          <Route path = "/admin" element = {<Admin/>}/>
        </Routes>
      </div>
    </>
  );
}

export default App;
